export const StateSchoolListColumn = [
    {
        label: "s_n",
        name: "S.N"
    },
    {
        label: "schoolName",
        name: "School Name"
    },
    {
        label: "schoolId",
        name: "School ID"
    },
    {
        label: "loginCode",
        name: "Login Code"
    },
    {
        label: "UDISE_Code",
        name: "UDISE Code" // Grouped with ID for quick reference
    },
    // --- Location Data ---
    {
        label: "schoolAddress1",
        name: "School Address"
    },
    {
        label: "pinCode",
        name: "Pincode"
    },
    // --- Academic & Classification ---
    {
        label: "levelOfEducation",
        name: "Level of Education"
    },
    {
        label: "highestClass",
        name: "Highest Class"
    },
    {
        label: "schoolType",
        name: "School Type"
    },
    {
        label: "schoolMedium",
        name: "School Medium"
    },
     {
        label: "Status",
        name: "Status"
    },
    {
        label: "boardOfEducation",
        name: "Board of Education"
    },
    {
        label: "minority",
        name: "Minority Status"
    },
    // --- Status & Operations ---
    {
        label: "Status",
        name: "Status"
    },
    {
        label: "isSchoolClosed",
        name: "Is SchoolClose"
    },
    {
        label: "Actions",
        name: "Actions"
    }
];